import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import BlockLoading from '../../common/BlockLoading';
import NextV2 from '../../pagination/NextV2';
import PrevV2 from '../../pagination/PrevV2';

function GridSimple({
  title, data, element, 
  gridClassName, gridStyle, pagLimit, hasPagination = false,
  style, className, height 
}) {
  const [pagStart, setPagStart] = useState(0);
  const [pagEnd, setPagEnd] = useState(pagLimit);
  const [stack, setStack] = useState([])

  useEffect(() => {
    setStack([...data.map(x => x).splice(pagStart, pagLimit)])
  }, [data, pagStart, pagLimit])

  const prevStack = () => {
    let start = pagStart - pagLimit;
    start = (start < 0) ? 0 : start;
    updateStack(start);
  }

  const nextStack = () => {
    let start = pagStart + pagLimit;
    start = (start >= data.length) ? data.length : start;
    updateStack(start);
  }

  const updateStack = (start) => {
    const newStack = [...data.map(x => x).splice(start, pagLimit)];
    setPagStart(start);
    setPagEnd(start + pagLimit);
    setStack(newStack)
  }

  return (
    <div className={`flexColumn ${className}`} style={{ ...style, height }}>
      <div className={`flexRow grid-headers`}>
        { title ? <span className={`bp-h5 type-regular type-light`}>{title}</span> : null }
      </div>
      <div className={`flexRow ${gridClassName}`} style={gridStyle}>
        { (hasPagination && pagStart !== 0) && <PrevV2 onClick={prevStack} /> }
        { stack.length > 0 
          ? [...stack].map( (x,i) => React.cloneElement(element, { key: `grid-element-${x.id}`, ...x, label: x.name }) )
          : <BlockLoading height={height} />
        }
        { (hasPagination && pagEnd < data.length) && <NextV2 onClick={nextStack} /> }
      </div>
    </div>
  )
}

GridSimple.propTypes = {
  data: PropTypes.any,
  height: PropTypes.any,
  title: PropTypes.string,
  hasPagination: PropTypes.bool,
  pagLimit: PropTypes.number,
  style: PropTypes.object,
  gridStyle: PropTypes.object,
  className: PropTypes.string,
  gridClassName: PropTypes.string,
  element: PropTypes.element.isRequired
}

export default GridSimple;
